import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vSelect from 'vue-multiselect';
import VCalendar from 'v-calendar';
import moment from 'moment';
import Vue2TouchEvents from 'vue2-touch-events';
import services from '@/services';
import DataTable from '@/components/DataTable/DataTable';
import collectionMixin from './mixins/collectionMixin';
import accessLevelMixin from './mixins/accessLevelMixin';
import utils from '@/utils';
import validator from '@/plugins/validator';

import UiCol from '@/components/ui/ui-col';
import UiRow from '@/components/ui/ui-row';
import UiAlert from '@/components/ui/ui-alert';
import UiProgress from '@/components/ui/ui-progress';
import UiTitle from '@/components/ui/ui-title';
import UiCard from '@/components/ui/ui-card';
import UiSwitch from '@/components/ui/ui-switch';
import UiTextField from '@/components/ui/ui-text-field';
import UiForm from '@/components/ui/ui-form';
import UiBtn from '@/components/ui/ui-btn';
import UiMenu from '@/components/ui/ui-menu';
import UiDialog from '@/components/ui/ui-dialog';
import UiTextarea from '@/components/ui/ui-textarea';
import UiTable from '@/components/ui/ui-table';
import UiPagination from '@/components/ui/ui-pagination';
import UiLabelSwitch from '@/components/ui/ui-label-switch';
import UiTabs from '@/components/ui/ui-tabs';
import UiTab from '@/components/ui/ui-tab';

Vue.component('ui-row', UiRow);
Vue.component('ui-col', UiCol);
Vue.component('ui-alert', UiAlert);
Vue.component('ui-progress', UiProgress);
Vue.component('ui-title', UiTitle);
Vue.component('ui-card', UiCard);
Vue.component('ui-switch', UiSwitch);
Vue.component('ui-text-field', UiTextField);
Vue.component('ui-form', UiForm);
Vue.component('ui-btn', UiBtn);
Vue.component('ui-menu', UiMenu);
Vue.component('ui-dialog', UiDialog);
Vue.component('ui-textarea', UiTextarea);
Vue.component('ui-table', UiTable);
Vue.component('ui-pagination', UiPagination);
Vue.component('ui-label-switch', UiLabelSwitch);
Vue.component('ui-tabs', UiTabs);
Vue.component('ui-tab', UiTab);
Vue.component('v-select', vSelect);
Vue.component('DataTable', DataTable);

Vue.use(VCalendar);
Vue.use(Vue2TouchEvents);

Vue.mixin(collectionMixin);
Vue.mixin(accessLevelMixin);

require('./assets/main.scss');
require('./directives/index');

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.prototype.$services = services;
Vue.prototype.$utils = utils;
Vue.prototype.$validator = validator;
Vue.prototype.$isAllowedTo = utils.capabilites.isAllowedTo;
Vue.prototype.$bus = new Vue();

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
